import React from "react";
import { Outlet } from "react-router-dom";
import OffersLayout from "../Layout/OffersLayout";

/**
 * Layout shell for Offers. Auth is enforced by AuthenticatedRoute; RBAC by AuthorizedRoute.
 */
const OffersRoute = () => (
	<OffersLayout>
		<Outlet />
	</OffersLayout>
);

export default OffersRoute;
